var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatePicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_Calendar",
    "data-name": "Icon/Calendar",
    d: "M14.858,4.192h-3.2V3.658a.533.533,0,1,0-1.067,0v.533h-3.2V3.658a.533.533,0,1,0-1.067,0v.533H4.458A1.334,1.334,0,0,0,3.125,5.525V17.792a1.334,1.334,0,0,0,1.333,1.333H17.791a1.334,1.334,0,0,0,1.333-1.333V5.525a1.334,1.334,0,0,0-1.333-1.333H15.924V3.658a.533.533,0,0,0-1.067,0Zm3.2,4.267v9.333a.266.266,0,0,1-.267.267H4.458a.266.266,0,0,1-.267-.267V8.458Zm-11.2,6.4a.533.533,0,1,1-.533.533A.533.533,0,0,1,6.858,14.858Zm2.133,0a.533.533,0,1,1-.533.533A.533.533,0,0,1,8.991,14.858Zm2.133,0a.533.533,0,1,1-.533.533A.533.533,0,0,1,11.125,14.858Zm2.133,0a.533.533,0,1,1-.533.533A.533.533,0,0,1,13.258,14.858Zm-6.4-2.133a.533.533,0,1,1-.533.533A.533.533,0,0,1,6.858,12.725Zm2.133,0a.533.533,0,1,1-.533.533A.533.533,0,0,1,8.991,12.725Zm2.133,0a.533.533,0,1,1-.533.533A.533.533,0,0,1,11.125,12.725Zm2.133,0a.533.533,0,1,1-.533.533A.533.533,0,0,1,13.258,12.725Zm2.133,0a.533.533,0,1,1-.533.533A.533.533,0,0,1,15.391,12.725Zm-6.4-2.133a.533.533,0,1,1-.533.533A.533.533,0,0,1,8.991,10.592Zm2.133,0a.533.533,0,1,1-.533.533A.533.533,0,0,1,11.125,10.592Zm2.133,0a.533.533,0,1,1-.533.533A.533.533,0,0,1,13.258,10.592Zm2.133,0a.533.533,0,1,1-.533.533A.533.533,0,0,1,15.391,10.592Zm.533-5.333v.533a.533.533,0,1,1-1.067,0V5.258h-3.2v.533a.533.533,0,1,1-1.067,0V5.258h-3.2v.533a.533.533,0,1,1-1.067,0V5.258H4.458a.266.266,0,0,0-.267.267V7.392H18.058V5.525a.266.266,0,0,0-.267-.267Z",
    transform: "translate(-3.125 -3.125)",
    fill: "currentColor",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePicker);
export default __webpack_public_path__ + "static/media/DatePicker.d88e235e.svg";
export { ForwardRef as ReactComponent };